import { isEmptyString } from '../string-utils';

export const isValidUrl = (url: string | null | undefined): boolean => {
	if (isEmptyString(url)) {
		return false;
	}
	try {
		const urlTest = new URL(url as string); // isEmptyString checks for null/undefined input
		return !isEmptyString(urlTest.origin);
	} catch (_) {
		return false;
	}
};
